import { AttachmentDialogComponent } from './attachment-dialog.component';
import { DialogsConfigService } from '@nrwl/dialog-configs';
import { Injectable } from '@angular/core';
import { RxTextCompositeComponent } from '@nrwl/rx-forms';

@Injectable({
  providedIn: 'root',
})
export class AttachmentDialogService extends DialogsConfigService {
  constructor() {
    super();
  }

  public AddAttachment() {
    return {
      component: AttachmentDialogComponent,
      panelClass: 'attachment-dialog',
      hideHeader: true,
      width: '300px',
      payload: {
        title: 'Add Attachment',
        subTitle: 'Select a photo from client record or upload images from device.',
        data: [],
      },
    };
  }

  public ConfirmSubmit() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Submit Form?',
        tip: 'Please review your form and confirm that all data is correct.<br/><br/>Once you pressed "Submit", the form will be submitted to your provider.',
        buttons: this.SubmitDismissButtons('Submit', 'Review'),
      },
    };
  }

  public ValidationError() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: 'Please fill in all the required fields.',
        disableClose: false,
        buttons: this.DismissButton('Review'),
      },
    };
  }
}
